import React, { Component } from 'react';
import { translate } from 'react-i18next';
import axios from 'axios';
import Navbar from '../Navbar.js';

let cancelToken;

class Promocode extends Component {
    constructor(props) {
        super(props);
        this.state = {
            member_id: this.props.user.memberId,
            msg: '',
            succesCode: false,
            errorCode: false
        };
    }

    componentWillMount() {
        cancelToken = axios.CancelToken.source();
    }

    // CREAR OBJETO PARA MANDARLO COMO PARAMETRO AL WEB SERVICE
    handleSubmit = (event) => {
        event.preventDefault();
        let params = this.state;  
        params.token_id = this.props.getTokenId();
        this.props.post(
            "/promocodeSocio",
            params,
            (response) => this.responsePromocode(response),
            (error) => this.props.handleErrorResponse(error),
            cancelToken
        );
    }

    // Validar promocode
    responsePromocode = (response) => {
        this.setState({msg: response.msg});
        if (response.code === 9998) {
            this.setState({succesCode: true});
            this.setState({errorCode: false});
        } else {
            this.setState({succesCode: false});
            this.setState({errorCode: true});
        }
    }

    // SE CREA ARREGLO CON VALORES DEL FORMULARIO PARA ENVIARLOS AL WEB SERVICE
    handleInputChange = (event) => {
        let name = event.target.name;
         this.setState({
             [name]: event.target.value
         });
     }
    render() {
        return(
            <div>
                <div className="panel panel-default" style={{marginTop: "10%"}}>
                    <div className="panel-body " style={{background:" #f0f0f0ad"}}>
                        <form method="post" onSubmit={this.handleSubmit} >
                            <div className="row" >
                                <h4 className="page-header text-primary col-xs-12" style={title}>
                                    <strong>INGRESA TU PRMOCODE</strong>
                                </h4>
                            </div>
                            <div className="form-group col-xs-12">
                                <div className="form-group" style={{position: 'relative'}}>
                                    <input className="form-control" id="code" name="promocode" onChange={this.handleInputChange} placeholder="¿Cuentas con un código de promoción? Ingrésalo aqui..." type="text" style={{padding: '25px'}}/>
                                    <button style={validatePromocode} type="submit" onClick={this.handlePromocode}>Aplicar</button>
                                </div>
                            </div>
                            {this.state.succesCode ? this.correctPromocode() : ""}
                            {this.state.errorCode ? this.errorPromocode() : ""}
                        </form>
                    </div>
                </div>
            </div>
        );
    }
    // MENSAJE DE PROMOCODE VALIDO
    correctPromocode = () => {
        return (
            <div className="form-group" style={succesCode}>
                <center><p style={{color: '#22c40a7d', fontSize: 'medium'}}><i className="fa fa-check-square" aria-hidden="true"></i> {this.state.msg}</p></center>
            </div>
        );
    }

    // MENSAJE DE PROMOCODE INVALIDO
    errorPromocode = () => {
        return (
            <div className="form-group" style={errorCode}>
                <center><p style={{color: '#f27428', fontSize: 'medium'}}><i className="fa fa-exclamation-triangle" aria-hidden="true"></i> {this.state.msg}</p></center>
            </div>
        );
    }
}


const title = {
    background: '#21B3B3',
    color: '#fff',
    fontSize: 'LARGE',
    fontWeight: '700',
    padding: '16px',
    paddingRight: '56px',
    textAlign: 'center',
    marginTop: 'auto',
    top: '-15px',
}
const validatePromocode = {
    position: 'absolute',
    right: '10px',
    top: '7px',
    border: 'none',
    background: '#ff6e40',
    borderRadius: '3px',
    padding: '10px',
    color: '#fff',
    transition: 'all .2s',
    fontSize: 'small'
}

const succesCode = {
    borderRadius: '3px',
    border: '2px solid #22c40a7d',
    borderLeft: '0px',
    borderTop: '0px',
    borderRight: '0px',
}

const errorCode = {
    borderRadius: '3px',
    border: '2px solid #f27428',
    borderLeft: '0px',
    borderTop: '0px',
    borderRight: '0px',
}

export default translate('common')(Promocode);

  


// WEBPACK FOOTER //
// ./src/dashboard/promocode/Promocode.js